import React, { useState, useEffect } from "react";
import api from "../api";
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  TablePagination,
  Box,
  useMediaQuery
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

// Normalize UI period to backend values
const normalizePeriod = (period) => {
  switch (period.toLowerCase()) {
    case "today":
      return "today";
    case "weekly":
      return "week";
    case "monthly":
      return "month";
    default:
      return "today";
  }
};

function OrdersGrid({ period }) {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // 👈 detect mobile

  useEffect(() => {
    setLoading(true);
    api.get(`/Dashboard/orders/${normalizePeriod(period)}`)
      .then(res => {
        setOrders(res.data);
        setPage(0);
        setError(null);
      })
      .catch(err => {
        console.error("Error fetching orders:", err);
        setError("Failed to load orders");
      })
      .finally(() => setLoading(false));
  }, [period]);

  const formatDate = (dateStr) => dateStr ? dateStr.split("T")[0] : "";

  return (
    <Card sx={{ margin: 2 }}>
      <CardContent>
        <Typography
          variant="h6"
          gutterBottom
          sx={{ fontWeight: "bold", color: "#2563EB" }}
        >
          📑 Orders
        </Typography>

        {loading && <CircularProgress size={24} />}
        {error && <Typography color="error">{error}</Typography>}

        {!loading && !error && (
          orders.length > 0 ? (
            <>
              {/* Responsive scroll wrapper */}
              <Box sx={{ width: "100%", overflowX: "auto" }}>
                <Table
                  size={isMobile ? "small" : "medium"} // 👈 compact table on mobile
                  sx={{ minWidth: 500 }}
                >
                  <TableHead sx={{ backgroundColor: "#f9fafb" }}>
                    <TableRow>
                      <TableCell>Invoice</TableCell>
                      <TableCell>Customer</TableCell>
                      <TableCell align="right">Total</TableCell>
                      <TableCell align="right">Date</TableCell>
                      <TableCell align="right">Time</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {orders
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((o, idx) => (
                        <TableRow key={idx} hover>
                          <TableCell>{o.invoice_number}</TableCell>
                          <TableCell>{o.custName?.trim()}</TableCell>
                          <TableCell align="right">₹{o.total}</TableCell>
                          <TableCell align="right">{formatDate(o.aDate)}</TableCell>
                          <TableCell align="right">{o.aTime}</TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </Box>

              {/* Pagination controls */}
              <TablePagination
                component="div"
                count={orders.length}
                page={page}
                onPageChange={(e, newPage) => setPage(newPage)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => {
                  setRowsPerPage(parseInt(e.target.value, 10));
                  setPage(0);
                }}
                rowsPerPageOptions={[5, 10, 25]}
                labelRowsPerPage={isMobile ? "" : "Rows per page"} // 👈 hide label on mobile
              />
            </>
          ) : (
            <Typography>No orders found</Typography>
          )
        )}
      </CardContent>
    </Card>
  );
}

export default OrdersGrid;